import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { createMuiTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';

import PageTemplate from './PageTemplate.js';

import { fetch_data_v2 } from './fetchhandler.js';

const useStyles = makeStyles(theme => ({
	formContainer: {
		backgroundColor: "#FFF",
		paddingTop: 10,
	},
	emailContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	emailTextField: {
		width: '62%',
	},
	complainContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	complainTextField: {
		width: '62%',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	}
}));

const downloadPageTexttheme = createMuiTheme({
	palette: {
		primary: { main: "#f6feff" },
		secondary: { main: "#ffe3ff" },
	},
});

export default function DownloadPage() {
	const [emailText, setEmailText] = useState("");
	const [complainText, setComplainText] = useState("");
	const [dataCanBeSubmited, setDataCanBeSubmited] = useState(true);
	const classes = useStyles();
	const l_content = <div className={classes.formContainer}>
		<Grid container spacing={2} justify="center">
			<Grid item xs={12} className={classes.emailContainer}>
				<TextField
					id="outlined-helperText"
					label="Your Email"
					className={classes.emailTextField}
					helperText="Please provide your email so that we can reach you."
					variant="outlined"
					onChange={(e) => setEmailText(e.target.value)}
				/>
			</Grid>
			<Grid item xs={12} className={classes.complainContainer}>
				<TextField
					id="outlined-multiline-static"
					label="Complain"
					className={classes.complainTextField}
					multiline
					rows={12}
					defaultValue=""
					variant="outlined"
					helperText="Please tell us about your complain and let us get back soon."
					onChange={(e) => setComplainText(e.target.value)}
				/>
			</Grid>
			<Grid item xs={12} className={classes.buttonContainer}>
				<Button
					disabled={!dataCanBeSubmited}
					variant="contained"
					onClick={() => {
						if (!dataCanBeSubmited) {
							alert("Complain already submitted.");
							return;
						};
						setDataCanBeSubmited(false);
						let l_method = "POST";
						let l_uri = "https://arithmetixcrush.computatus.com:61976/complain";
						let l_extra_headers = {};
						let l_body = {
							email: emailText,
							complainText: complainText,
						};
						let l_fnc = ((p_resp) => {
							if (p_resp.result === "OK") {
								// do nothing								
							}
							else {
								setDataCanBeSubmited(true);
								alert(p_resp.message);
							};
						});
						fetch_data_v2(l_method, l_uri, l_extra_headers, l_body, l_fnc);
					}}
				>
					Submit
					</Button>
			</Grid>
		</Grid>
	</div>;
	let l_thankYou = <ThemeProvider theme={downloadPageTexttheme}>
		<Typography variant="h6" align="center" color="secondary" paragraph>
			{"Your complain is submitted. We apologize for the inconvinience. Our engineers will work on the subject and try to solve as soon as possible."}
		</Typography>
	</ThemeProvider>;
	return <PageTemplate>{dataCanBeSubmited ? l_content : l_thankYou}</PageTemplate>;
}

